import {Trans} from '@lingui/macro';
import React from 'react';

/*
 * Helpers.
 */

export function buildInfoBoxToggleLabel() {
  return <Trans id="contacts-manager-info-box-toggle-label">Toggle info boxes</Trans>;
}
